import { Dispatch, FC, Fragment, SetStateAction, SyntheticEvent, useState } from "react";
import { IPays } from "../Pays/Pays";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent,
  Collapse, Divider, IconButton, List, ListItem, ListItemText, Stack, Table,
  TableBody, TableCell, TableHead, TableRow, Typography, styled, tableCellClasses
} from "@mui/material";
import { btnStyle } from "../user/Tabs/utilisateur/UtilisateurRow";
import ManagerOperationForm from "../../../forms/ManagerOperationForm";
import { UserManagerOperationInterface } from "./UserManagerOperationInterface";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { cellStyle } from "../Pays/RowPays";
import { AxiosInstance } from "axios";
import { AlertType } from "../../../../types/AlertType";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import { ClientWithOperations } from "./ManagerOperation";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

interface ManagerOperationRowProps {
  row: UserManagerOperationInterface;
  isDesktopOrLaptop: boolean;
  dataRefPaysBu: IPays[];
  clientWithOperations: ClientWithOperations[];
  http: AxiosInstance;
  expanded: number | false;
  setExpanded: Dispatch<React.SetStateAction<number | false>>;
  handleRefresh: () => void;
  setOpenSnack: Dispatch<SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<SetStateAction<string>>;
  setAlertType: Dispatch<SetStateAction<AlertType>>;
}

const ManagerOperationRow: FC<ManagerOperationRowProps> = ({
  row,
  isDesktopOrLaptop,
  dataRefPaysBu,
  clientWithOperations,
  http,
  expanded,
  setExpanded,
  handleRefresh,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleChangeAccordionValue = (panel: number) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClose = () => {
    setOpenModal(false);
  }

  const usersPays = () => {
    const tabPays: string[] = [];
    for (let pays of row?.pays) {
      tabPays.push(pays?.libelle);
    }

    return tabPays.join(' / ');
  }

  return (
    <Fragment>
      {isDesktopOrLaptop ? (
        <>
          <TableRow>
            <StyledTableCell>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
                sx={{ color: "#fff", fontSize: 12 }}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </StyledTableCell>
            <StyledTableCell>{row?.prenom}</StyledTableCell>
            <StyledTableCell>{row?.name}</StyledTableCell>
            <StyledTableCell>{usersPays()}</StyledTableCell>
            <StyledTableCell>
              <Button
                size="small"
                variant="outlined"
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
                sx={btnStyle({
                  bgColor: "#070d23",
                  hoverColor: "Gray",
                  color: "#fff",
                })}
              >
                Modifier
              </Button>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <TableCell style={cellStyle} colSpan={5}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell style={cellStyle}>
                          Client
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle}>
                          Opération
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/*teste Les MO client DS Null et operation DS NULL*/}
                      {row?.manager_operation?.filter(mo => mo?.operations?.date_suppression === null).filter(mo => mo?.operations?.client?.date_suppression === null).map((item) => (
                        <TableRow>
                          <TableCell style={cellStyle} align="center">
                            {item?.operations?.client?.libelle}
                          </TableCell>
                          <TableCell style={cellStyle} align="center">
                            {item?.operations?.libelle}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      ) : (
        <Accordion
          expanded={expanded === row?.id}
          onChange={handleChangeAccordionValue(row?.id)}
          sx={{
            borderRadius: 1,
            bgcolor: '#fff',
            mb: 1,
            ml: 0.1
          }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#080d24' }} />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Stack direction="column">
              <List sx={{ py: 0 }} dense>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Prénom :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {row?.prenom}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Nom :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {row?.name}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Pays :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {usersPays()}
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Stack direction='column' spacing={1}>
              <Button
                variant="contained"
                sx={btnStyle({
                  bgColor: "Gray",
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                size='small'
                fullWidth
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
              >
                Modifier
              </Button >
              <Box>
                <Typography gutterBottom variant="h5" component="div" sx={{ mb: 0, mt: 2 }}>
                  Ses opérations
                </Typography>
                <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 1 }} />
              </Box>

              {row?.manager_operation?.filter(mo => mo?.operations?.date_suppression === null).filter(mo => mo?.operations?.client?.date_suppression === null).map((item) => (
                <Card>
                  <CardContent>
                    <List dense>
                      <ListItem dense>
                        <ListItemText
                          primary="Client :"
                          secondary={item?.operations?.client?.libelle}
                        />
                      </ListItem>
                      <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                      <ListItem dense>
                        <ListItemText
                          primary="Opération :"
                          secondary={item?.operations?.libelle}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}

      <OptionalWidthModal
        title="Modifier Manager Par Operation"
        onClose={handleClose}
        open={openModal}
        breackPoint="md"
      >
        <ManagerOperationForm
          row={row}
          dataRefPaysBu={dataRefPaysBu}
          // clientWithOperations={clientWithOperations}
          onClose={handleClose}
          handleRefresh={handleRefresh}
          http={http}
          setOpenSnack={setOpenSnack}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
        />
      </OptionalWidthModal>
    </Fragment>
  );
};

export default ManagerOperationRow;
